import { WifiOff, Wifi } from 'lucide-react';
import { usePWA } from '@/hooks/usePWA';
import { useEffect, useState } from 'react';

export function OfflineIndicator() {
  const { isOnline } = usePWA();
  const [wasOffline, setWasOffline] = useState(false);
  const [showReconnected, setShowReconnected] = useState(false);

  useEffect(() => {
    if (!isOnline) {
      setWasOffline(true);
    } else if (wasOffline && isOnline) {
      // Show reconnected message temporarily
      setShowReconnected(true);
      const timer = setTimeout(() => {
        setShowReconnected(false);
        setWasOffline(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [isOnline, wasOffline]);

  // Show offline indicator
  if (!isOnline) {
    return (
      <div className='fixed top-0 left-0 right-0 z-50 bg-yellow-500 text-yellow-950 px-4 py-2 text-center text-sm font-medium'>
        <div className='flex items-center justify-center gap-2'>
          <WifiOff className='h-4 w-4' />
          <span>You are currently offline. Some features may be limited.</span>
        </div>
      </div>
    );
  }

  // Show reconnected message briefly
  if (showReconnected) {
    return (
      <div className='fixed top-0 left-0 right-0 z-50 bg-green-500 text-white px-4 py-2 text-center text-sm font-medium'>
        <div className='flex items-center justify-center gap-2'>
          <Wifi className='h-4 w-4' />
          <span>Back online</span>
        </div>
      </div>
    );
  }

  return null;
}
